<template>
  <div class="accessories-root">
    <img v-if="dark" src="../../../assets/stamp/accessories-d.svg" alt="Accessories" />
    <img v-else src="../../../assets/stamp/accessories-l.svg" alt="Accessories" />
  </div>
</template>

<script>
export default {
  name: 'Accessories',
  props: {
    dark: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.accessories-root {
  @apply relative mx-auto flex justify-center items-center;
  max-width: 400px;
  width: 80%;
  height: 80%;
}
</style>
